import apiClient from './api'

export const salesOrderService = {
  /**
   * Recupera la lista degli ordini dell'utente autenticato
   */
  async getMyOrders() {
    try {
      const response = await apiClient.get('/salesorders')
      return response.data
    } catch (error) {
      console.error('[SalesOrderService] Errore nel recupero degli ordini:', error)
      throw error
    }
  },

  /**
   * Recupera i dettagli di un singolo ordine
   */
  async getOrderDetails(orderId) {
    try {
      const response = await apiClient.get(`/salesorders/${orderId}`)
      return response.data
    } catch (error) {
      console.error(`[SalesOrderService] Errore nel recupero dell'ordine ${orderId}:`, error)
      throw error
    }
  },

  /**
   * Elimina un ordine (consentito solo per stati specifici come PendingPayment)
   */
  async deleteOrder(orderId) {
    try {
      const response = await apiClient.delete(`/salesorders/${orderId}`)
      return response.data
    } catch (error) {
      console.error(`[SalesOrderService] Errore nell'eliminazione dell'ordine ${orderId}:`, error)
      throw error
    }
  }
}

export default salesOrderService
